import _ from 'lodash';
import { DeviceType, Data } from './model';
import * as Devices from '../devices';
import * as DTHelper from '../datatable/utils';
import { AppKeys, newMsg } from '../../core/localization';
import { GroupNames, Groups } from '../../models';

export const msgTitle = newMsg(GroupNames[Groups.DEVICETYPES]);
export const msgDeviceName = newMsg(AppKeys.Device_Prop_DeviceName);
export const msgNumDevices = newMsg(AppKeys.Groups_Col_NumDevices);
export const keyTotalDTypes = AppKeys.Num_DTypes;
export const msgSearchError = newMsg(AppKeys.DTypes_Search_Error);

export const getPK = (dType: DeviceType): string => dType.deviceName;

export const getLoadedDTypes = DTHelper.concatPageItems;

export const getSelectedDTypes = (
  loadedDTypes: DeviceType[],
  selectedKeys: string[]
) => loadedDTypes.filter((d) => selectedKeys.includes(getPK(d)));

export const getNumDevicesFromDTypes = (selectedKeys: string[], data: Data) => {
  const dTypes = getSelectedDTypes(getLoadedDTypes(data.pages), selectedKeys);
  return _.sum(dTypes.map((o) => o.numDevices));
};

export const getTotalsFromSelectedKeys = (
  selectedKeys: string[],
  data: Data
) => {
  const dTypes = getSelectedDTypes(getLoadedDTypes(data.pages), selectedKeys);
  return dTypes
    .map((o) => o.totalsByType)
    .reduce(
      (prev, t) => {
        prev.totalConcentrators += t.totalConcentrators;
        prev.totalGateways += t.totalGateways;
        prev.totalMeters += t.totalMeters;
        prev.totalRepeaters += t.totalRepeaters;
        prev.totalValves += t.totalValves;
        return prev;
      },
      { ...Devices.TotalsByTypeDefault }
    );
};
